import { render } from "./ExpertStatisticsOutboundPbx.vue?vue&type=template&id=370e8836"
import script from "./ExpertStatisticsOutboundPbx.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutboundPbx.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutboundPbx.vue?vue&type=style&index=0&id=370e8836&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__